// extracted by mini-css-extract-plugin
export var contentBody = "_5y-9";
export var headerImage = "_5y-2";
export var imageButton = "_5y-7";
export var imageButtonIcon = "_5y-8";
export var imageHeader = "_5y-4";
export var imageHeaderText = "_5y-5";
export var imageOverlay = "_5y-3";
export var imageTitle = "_5y-6";
export var imageWrapper = "_5y-1";
export var taskList = "_5y-a";
export var widget = "_5y-0";